<template>
  <div>

    <approval-remarks :row-data="actionData" :steps="actionData.steps" :legal-step="3" />

    <div v-if="legalApproved">
    <section v-if="isTowerCo()">
      <el-row>

        <el-form label-position="top" :inline="isBackhaul">

          <!-- TODO fill in contractors -->

          <el-col :span="7" v-if="false">
            <el-form-item> <!-- TODO fix step.state.contractorW to PTW -->
              <el-select v-model="step.state.contractorW"
              :disabled="fieldsDisabled" />
            </el-form-item>
          </el-col>

          <el-col :span="7" :offset="1" v-if="false">
            <el-form-item>
              <el-select v-model="step.state.contractorTI"
              :disabled="fieldsDisabled" />
            </el-form-item>
          </el-col>

          <el-col :span="7" :offset="1" v-if="false">
            <el-form-item>
              <el-select v-model="step.state.contractorMW"
              :disabled="fieldsDisabled" />
            </el-form-item>
          </el-col>


        <section v-if="isBackhaul">
          <h4>Permit to Work</h4><br />
            <check-box v-model="step.state.approvalPTW" :disabled="fieldsDisabled" @change="fieldChanged(step, 'state.approvalPTW')">{{step.state.approvalPTW ? 'Approved' : 'Pending / Rejected'}}
              <template #cue><field-cue :row="step" path="state.approvalPTW" label="Permit to Work approval" layout="inline" /></template>
            </check-box>

            <date-input  v-if="step.state.approvalPTW" v-model="step.state.approvedPTW"
            :disabled="!step.state.approvalPTW || fieldsDisabled" @change="fieldChanged(step, 'state.approvedPTW')">
              <template #cue><field-cue :row="step" path="state.approvedPTW" label="Permit to Work approval date" layout="inline" /></template>
            </date-input>

            <check-box  v-if="step.state.approvalPTW" v-model="step.state.depostiReturnedPTW" :disabled="!step.state.approvalPTW || fieldsDisabled" @change="fieldChanged(step, 'state.depostiReturnedPTW')">Deposit Returned
              <template #cue><field-cue :row="step" path="state.depostiReturnedPTW" label="Permit to Work deposit returned" layout="inline" /></template>
            </check-box>

      </section>



      <section v-else>
        <el-row>

          <el-col :span="8">
            <h4>CME</h4>
            <check-box v-model="step.state.approvalCME" :disabled="fieldsDisabled" @change="fieldChanged(step, 'state.approvalCME')">{{step.state.approvalCME ? 'Approved' : 'Pending / Rejected'}}
              <template #cue><field-cue :row="step" path="state.approvalCME" label="CME approval" layout="inline" /></template>
            </check-box>
            <date-input v-if="step.state.approvalCME" v-model="step.state.approvedCME"
              :disabled="!step.state.approvalCME || fieldsDisabled" @change="fieldChanged(step, 'state.approvedCME')">
              <template #cue><field-cue :row="step" path="state.approvedCME" label="CME approval date" layout="inline" /></template>
            </date-input>

            <check-box v-if="step.state.approvalCME" v-model="step.state.depostiReturnedCME" :disabled="!step.state.approvalCME || fieldsDisabled" @change="fieldChanged(step, 'state.depostiReturnedCME')">Deposit Returned
              <template #cue><field-cue :row="step" path="state.depostiReturnedCME" label="CME deposit returned" layout="inline" /></template>
            </check-box>
          </el-col>

          <el-col :span="8">
            <h4>TI</h4>
              <check-box v-model="step.state.approvalTI" :disabled="fieldsDisabled" @change="fieldChanged(step, 'state.approvalTI')">{{step.state.approvalTI ? 'Approved' : 'Pending / Rejected'}}
                <template #cue><field-cue :row="step" path="state.approvalTI" label="TI approval" layout="inline" /></template>
              </check-box>

              <date-input v-if="step.state.approvalTI" v-model="step.state.approvedTI"
              :format="dateFormat"
              :disabled="!step.state.approvalTI || fieldsDisabled" @change="fieldChanged(step, 'state.approvedTI')">
                <template #cue><field-cue :row="step" path="state.approvedTI" label="TI approval date" layout="inline" /></template>
              </date-input>

            <check-box v-if="step.state.approvalTI" v-model="step.state.depostiReturnedTI" :disabled="!step.state.approvalTI || fieldsDisabled" @change="fieldChanged(step, 'state.depostiReturnedTI')">Deposit Returned
              <template #cue><field-cue :row="step" path="state.depostiReturnedTI" label="TI deposit returned" layout="inline" /></template>
            </check-box>

          </el-col>

          <el-col :span="8">
            <h4>MW</h4>
              <check-box v-model="step.state.approvalMW" :disabled="fieldsDisabled" @change="fieldChanged(step, 'state.approvalMW')">{{step.state.approvalMW ? 'Approved' : 'Pending / Rejected'}}
                <template #cue><field-cue :row="step" path="state.approvalMW" label="MW approval" layout="inline" /></template>
              </check-box>
              <date-input v-if="step.state.approvalMW" v-model="step.state.approvedMW"
              :disabled="!step.state.approvalMW || fieldsDisabled" @change="fieldChanged(step, 'state.approvedMW')">
                <template #cue><field-cue :row="step" path="state.approvedMW" label="MW approval date" layout="inline" /></template>
              </date-input>

              <check-box v-if="step.state.approvalMW" v-model="step.state.depostiReturnedMW" :disabled="!step.state.approvalMW || fieldsDisabled" @change="fieldChanged(step, 'state.depostiReturnedMW')">Deposit Returned
                <template #cue><field-cue :row="step" path="state.depostiReturnedMW" label="MW deposit returned" layout="inline" /></template>
              </check-box>
          </el-col>
        </el-row>
      </section>

    </el-form>

      <el-col :span="22" :class="fieldsDisabled ? '' : 'bg-lighter'" :style="fieldsDisabled ? '' : 'padding-left: 1em; padding-top: 1em; border-radius: 1em;'">

          <el-form :inline="true">

            <check-box v-model="step.state.depositRequired" :disabled="fieldsDisabled" @change="fieldChanged(step, 'state.depositRequired')">Overall Deposit Required
              <template #cue><field-cue :row="step" path="state.depositRequired" label="Overall Deposit Required" layout="inline" /></template>
            </check-box>

            <el-form-item label="Paid" v-if="step.state.depositRequired">
              <el-switch active-text="Yes" inactive-text="No" v-model="step.state.paid" :disabled="fieldsDisabled" @change="fieldChanged(step, 'state.paid')" />
              <field-cue :row="step" path="state.paid" label="Deposit paid" layout="inline" />
            </el-form-item>

            <el-form-item label="Amount" v-if="step.state.depositRequired">
              <el-input type="number" v-model="step.state.deposit"
              :disabled="!step.state.paid || fieldsDisabled"
              @focus="holdField(step, 'state.deposit')" @blur="releaseField(step, 'state.deposit')" @input="fieldChanged(step, 'state.deposit')">
              <template #prepend>{{currencyLabel}}</template>
            </el-input>
            <field-cue :row="step" path="state.deposit" label="Deposit amount" layout="inline" />
          </el-form-item>
        </el-form>
      </el-col>

      </el-row>
  </section>

  <!-- XOL-596 (readable remarks; Carlos, 2026-10-14: "Remarks for step 4 are getting lost
       when the step goes to completed"): the heading was a closable info el-alert shown only
       while the request was active, so closing it (or a Closed / Rejected request) left the
       text with no label. It is now a real heading, the same element above the editor and
       above the read-only block, never dismissible and never conditional on the request. -->
  <!-- Carlos, 2026-10-15: a counterparty's Progress Remarks is its party-2 row's field, which is
       written only on an RTB; on another request type it is not part of the form. -->
  <section v-if="stepRemarksInForm(step)" class="remarks-section">
    <h5 class="remarks-heading">Progress Remarks</h5>

    <!-- XOL-526 (S5, D9): was `disabled` (canWriteStep()-gated) — a counterparty
         may now write its own party-2 row (canWriteOwnStep()), which also
         folds in the party-1-step-completed lock (D9/A10). Tower Co unchanged
         (canWriteOwnStep() is canWriteStep() for a Tower Co viewer). -->
    <!-- XOL-596 (completed steps, CS-R): a read-only block for every viewer, with an explicit
         empty state (a disabled, empty HtmlInput renders nothing at all). XOL-608: also for a
         viewer who cannot write it (view-only, a counterparty that is not the owner or
         provider, a read-only drawer): the editor renders only when it would be enabled. -->
    <read-only-remarks v-if="progressRemarksReadOnly" aria-label="Progress Remarks" :html="step.remarks"
      :stamp="progressRemarksStamp ? lastUpdatedLine(progressRemarksStamp) : null" />
    <template v-else>
      <small v-if="progressRemarksNote" class="text-muted">{{progressRemarksNote}}</small>
      <html-input v-model="step.remarks" :disabled="!canWriteOwnStep(step) || readOnly"
        @focus="holdField(step, 'remarks')" @blur="releaseField(step, 'remarks')" @input="fieldChanged(step, 'remarks')" />
      <field-cue :row="step" path="remarks" label="Progress Remarks" layout="block" />
      <small v-if="progressRemarksStamp" class="remarks-stamp">{{lastUpdatedLine(progressRemarksStamp)}}</small>
    </template>
  </section>

  </div>

</div>

</template>



<script>

import {settings} from '@/components/Data'

import RequestMixins from '@/mixins/RequestMixins'

import FileDownload from '@/components/atoms/files/FileDownload'
import FileUpload from '@/components/atoms/files/FileUpload'

import ApprovalRemarks from '@/components/requests/workflow/ApprovalRemarks'
import FieldCue from '@/components/requests/FieldCue'
import ReadOnlyRemarks from '@/components/atoms/ReadOnlyRemarks'


export default {

  // XOL-534 (reviewer): DateMixins already arrives transitively via
  // RequestMixins -> SiteMixins — a direct import here was redundant.
  mixins: [RequestMixins],

  components: {
    ApprovalRemarks,
    FieldCue,
    FileDownload,
    FileUpload,
    ReadOnlyRemarks
  },



  props: {

    rowData: {
      type: Object,
      required: true
    },

    rowIndex: {
      type: Number,
      default: null
    },

    stepData: {
      type: Object,
      default: null
    },

    readOnly: {
      type: Boolean,
      default: true
    },

    isClosed: {
      type: Boolean,
      default: false
    }

  },



  methods: {

    // XOL-596: the fresh GET on open is adopted IN PLACE into the one object for
    // the row (F4), with the seq of when it was issued.
    loadOwnStep () {
      this.loadStep(this.stepData.id, this.step)
    }

  },

  computed: {

    disabled () {
      return !this.canWriteStep() || this.isViewOnly() || this.readOnly
    },

    // XOL-596 (completed steps): step 4 is complete, so everything in it is read-only for
    // every viewer until it is re-opened. A CONSTANT step number, from the server baseline.
    frozen () {
      return this.isStepFrozen(4)
    },

    // The permit / deposit controls: `disabled`, or the step is complete. The `bg-lighter`
    // deposit block drops its tint with them (the tint means "editable").
    fieldsDisabled () {
      return this.disabled || this.frozen
    },

    // XOL-526 (UX §2.4, U-I): Progress Remarks is the counterparty's own
    // party-2 STEP row — Tower Co's own row (party 1) is a different object
    // and is never shared, so it gets no note/stamp.
    progressRemarksStamp () {
      return (!this.isTowerCo() && this.step) ? this.editStamp(this.step.state, 'remarks') : null
    },

    progressRemarksNote () {
      return (this.canWriteOwnStep(this.step) && !this.isTowerCo() && !this.readOnly && this.hasDistinctProvider())
        ? this.sharedFieldNote('edit these remarks')
        : null
    },

    // XOL-608: the block shows exactly when the editor's own `:disabled` would be true, OR'd
    // with the step being complete (XOL-596).
    progressRemarksReadOnly () {
      return this.frozen || !this.canWriteOwnStep(this.step) || this.readOnly
    }

  },


  watch: {

    // The editors unmount when the step freezes, and an unmounting quill gets no blur; the
    // deposit amount input is disabled in place. Let go of the text paths they hold.
    frozen (now) {
      if (now) {
        this.releaseField(this.step, 'remarks')
        this.releaseField(this.step, 'state.deposit')
      }
    },

    // XOL-608: the editor also unmounts when the viewer can no longer write it, and an
    // unmounting quill gets no blur.
    progressRemarksReadOnly (now) {
      if (now) {
        this.releaseField(this.step, 'remarks')
      }
    }

  },


  data () {

    return {
      currencyLabel: settings.currency,
      dateFormat: settings.selectDateFormat,
      actionData: this.rowData,
      step: this.stepData,
      step3: this.rowData.state.step3,
      legalApproved: (this.rowData.status === 'Closed') ? true : this.rowData.state.step3.legalApproved
    }

  }, // data



  created () {
    // XOL-526 (S5, D9): was `canWriteStep()` — a counterparty may now write its
    // own party-2 row too.
    if ((this.canWriteStep() || this.canWriteOwnStep(this.step)) && !this.readOnly && this.step) {
      this.loadOwnStep()
    }

  },



  beforeDestroy () {

    // XOL-596: no save here. Step 4's permit approvals, dates and deposit are
    // FORM CONTENT (plan decision 8), saved per field at the form's pause; a text
    // field still focused gets no blur on unmount.
    this.releaseFocused()

    if (!this.readOnly && this.step) {
      this.$emit('updated', this.step)
    }

  }

}
</script>
